/**
 * Tab Links — Per-Tab Memory
 *
 * Each tab (In Stock / Custom / Accessories) remembers the LAST product
 * the user visited on that tab. Switching tabs and coming back always
 * returns to where you left off — like real browser tabs.
 *
 * Query params: tab-ready, tab-custom, tab-accessories
 * Each stores the product handle last visited on that tab.
 *
 * All logic runs client-side to avoid Shopify CDN caching issues with Liquid.
 */
function initTabLinks() {
    var tabsContainer = document.querySelector('.product-type-tabs');
    if (!tabsContainer) return;
    var urlParams = new URLSearchParams(window.location.search);
    var activeTab = tabsContainer.getAttribute('data-active-tab') || '';
    var currentHandle = tabsContainer.getAttribute('data-current-handle') || '';

    // --- Build per-tab memory from URL query params ---
    var tabMemory = {
        ready: urlParams.get('tab-ready') || '',
        custom: urlParams.get('tab-custom') || '',
        accessories: urlParams.get('tab-accessories') || ''
    };

    // Update the current tab's memory with the current product handle
    if (activeTab && currentHandle) {
        tabMemory[activeTab] = currentHandle;
    }
    console.log('TabLinks per-tab memory', { activeTab, currentHandle, tabMemory: JSON.parse(JSON.stringify(tabMemory)) });
    // --- Helper: build query string with all tab memory params ---
    function buildTabParams(url) {
        if (tabMemory.ready) url.searchParams.set('tab-ready', tabMemory.ready);
        if (tabMemory.custom) url.searchParams.set('tab-custom', tabMemory.custom);
        if (tabMemory.accessories) url.searchParams.set('tab-accessories', tabMemory.accessories);
    }

    // --- Update each tab link ---
    var tabItems = tabsContainer.querySelectorAll('li[data-tab-type]');
    tabItems.forEach(function(li) {
        var a = li.querySelector('a');
        if (!a) return;
        var tabType = li.getAttribute('data-tab-type');
        if (!tabType) return;
        var href = a.getAttribute('href');
        var url;
        try {
            url = new URL(href, window.location.origin);
        } catch (e) {
            return;
        }
        // If this tab has a remembered product, override the URL
        if (tabMemory[tabType]) {
            url.pathname = '/products/' + tabMemory[tabType];
        }
        // Carry all tab memory params forward
        buildTabParams(url);
        a.setAttribute('href', url.pathname + url.search);
    });

    // --- Propagate tab memory params to ALL turbo-links on the page ---
    var allLinks = document.querySelectorAll('a.turbo-link');
    allLinks.forEach(function(a) {
        // Skip tab links (already handled above)
        if (a.closest('.product-type-tabs')) return;
        var href = a.getAttribute('href');
        if (!href || href.indexOf('/products/') !== 0) return;
        try {
            var url = new URL(href, window.location.origin);
            // Color change should reset context: never carry tab query params.
            if (a.classList.contains('color-swatch-link') || a.closest('.product-color-variants-wrapper')) {
                a.setAttribute('href', url.pathname);
                return;
            }
            buildTabParams(url);
            a.setAttribute('href', url.pathname + url.search);
        } catch (e) { /* skip invalid hrefs */ }
    });
}

document.addEventListener('DOMContentLoaded', initTabLinks);
document.addEventListener('swup:page:view', initTabLinks);